import React from 'react';
import classnames from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { getDeviationTitle } from '../../../_helpers';
import s from './FeedCardTitle.scss';
const FeedCardTitle = ({ deviation, className, disableScrollRestoration = true })=>{
    return /*#__PURE__*/ React.createElement(Heading, {
        className: classnames(s['title'], className)
    }, /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        disableScrollRestoration: disableScrollRestoration
    }, getDeviationTitle(deviation)));
};
FeedCardTitle.displayName = 'FeedCardTitle';
export default FeedCardTitle;
